import { RootState } from '@checkout/state';
import { Fragment } from 'react';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { CheckoutContextConfig } from '../../../apps/CheckoutApp';
import messages from './../../../i18n/base-en';
import { getCookie, setCookie } from './../../../utils/persistence';
import { Button, IconButton } from './../../presentational';
import * as Styles from './InformationBox.scss';

interface IOwnProps {}

interface IConnectedProps {}

interface IConnectetDispatchProps {}

type Props = IOwnProps & IConnectedProps & IConnectetDispatchProps & InjectedIntlProps;

interface IOwnState {
  isOpen: boolean;
  cookie: string;
}

class InformationBox extends React.Component<Props, IOwnState> {

  state: IOwnState = {
    isOpen: false,
    cookie: 'checkout-information'
  };

  componentDidMount() {
    this.setState({ isOpen: getCookie(this.state.cookie) === null });
  }

  open = () => {
    this.setState({ isOpen: true });
  }

  close = () => {
    const { cookie } = this.state;
    const today = new Date();
    const expires = new Date();

    // Expire for 14 days
    expires.setTime(today.getTime() + 3600000 * 24 * 14);

    this.setState(
      { isOpen: false },
      () => { setCookie(cookie, 'hidden', expires, '/'); }
    );
  }

  render() {
    const { intl } = this.props;
    const { formatMessage } = intl;

    return (
      <CheckoutContextConfig.Consumer>
        {(checkoutContextConfig => (
          <Fragment>
            {this.state.isOpen && (
              <div className={Styles.wrapper}>
                <div className={Styles.headerWrapper}>
                  <div className={Styles.header}>
                    <span className={Styles.headerText}>{formatMessage(messages.information_header_label)}</span>
                  </div>
                </div>
                <div
                  className={Styles.text}
                  dangerouslySetInnerHTML={{ __html: checkoutContextConfig.ui.informationBox.text }}
                />
                <div className={Styles.buttonsWrapper}>
                  <div className={Styles.buttons}>
                    <Button
                      type="button"
                      variant="primary"
                      width="short"
                      label={formatMessage(messages.information_button_label)}
                      onClick={this.close}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className={Styles.iconWrapper}><IconButton icon="information" onClick={this.open} /></div>
          </Fragment>
        ))}
      </CheckoutContextConfig.Consumer>
    );
  }
}

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({}),
    {},
  )
)(InformationBox);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/InformationBox/InformationBox.tsx